define([
	'angular'
],
function(angular) {

	var codFiscServices = angular.module('codFiscServices', []);

	codFiscServices.service('CFService', ['$log', CFService]);	

	function CFService($log) {
		$log.debug("INIZIO CF");
		// controllo formale del codice fiscale
		// Formato XXXXXX99X99XXXXX
		var _codFisc = function(cfins) { 
		   var cf = cfins.toUpperCase(); 
		   var cfReg = /^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z0-9]{5}$/; 
		   if (!cfReg.test(cf)) {return false;}
		   var set1    = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"; 
		   var set2    = "ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ"; 
		   var setpari = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"; 
		   var setdisp = "BAKPLCQDREVOSFTGUHMINJWZYX"; 
		   var s = 0; 
		   for (var i = 1; i <= 13; i += 2) 
		      s += setpari.indexOf(set2.charAt(set1.indexOf(cf.charAt(i)))); 
		   for (var i = 0; i <= 14; i += 2) 
		      s += setdisp.indexOf(set2.charAt(set1.indexOf(cf.charAt(i)))); 
		   if (s%26 != (cf.charCodeAt(15)-'A'.charCodeAt(0))) {return false;}
		   return true; 
		};

		var _partIva = function(s) {
			try {
				//s = s.trim();
				if (s.length != 11) return false;
				if (isNaN(s)) return false;

				// controlli validit� del codice ufficio
				var codUff  = s.substring(7,10);
				var iCodUff = parseInt(codUff,10);

				if (!((iCodUff >=   0 && iCodUff <= 100) ||
				      (iCodUff >= 120 && iCodUff <= 121) ||
				      (iCodUff >= 151 && iCodUff <= 245) ||
				      (iCodUff >= 301 && iCodUff <= 766) ||
				      (iCodUff >= 900 && iCodUff <= 950) ||
				      (iCodUff == 999))) {
					// Codice Ufficio non valido
					return false;
				}
				// controlli validit� del codice ufficio in riferimento al
				// valore della matricola
				var matr  = s.substring(0,7);
				var fMatr = parseFloat(matr);

				if (fMatr >= 8000000 && (iCodUff < 1 || iCodUff > 95)) {
					return false;
				}

				// verifica validit� della matricola per l'ufficio "000"
				if (iCodUff == 0) {
					if (!((fMatr >=       1 && fMatr <=  273960) ||
						  (fMatr >=  400001 && fMatr <= 1072480) ||
						  (fMatr >= 1500001 && fMatr <= 1828636) ||
						  (fMatr >= 2000001 && fMatr <= 2054095))) {
						return false;
					}
				}
				var appoggio;
				var appo;
				var ultimocarattere;
				var totale = 0;

				// Somma dei valori attribuiti alle cifre pari
				for (var i=1; i<11; i+=2) {
					var elem = s.substring(i,i+1);
					appoggio = parseInt(elem,10); //da una singola cifra della stringa passo ad un integer
					appo = parseInt(appoggio,10)*2; //passaggio ad un intero per moltiplicarlo
					var s2 = String(appo); // passo di nuovo a stringa per dividerla in due parti senza utilizzare un array
					for (var j=0; j<s2.length; j++) {
						var elem1 = s2.substring(j,j+1);
						totale += parseInt(elem1,10); //sommo il valore delle due cifre della stringa della somma
					}
				} 
				// Somma dei valori attribuiti alle cifre dispari
				for (var k=0; k<9; k+=2) {
				   var elem2 = s.substring(k,k+1);
				   totale += parseInt(elem2,10);
				}
				// estraggo l'ultima cifra della partita iva
				var elem = s.substring(10,11);
				appoggio = parseInt(elem,10);
				ultimocarattere = parseInt(appoggio,10);
				// controllo del complemento a dieci della cifra a destra del totale
				if (totale % 10 == 0) { 
			     	 return (totale % 10) == ultimocarattere;
				}else {
					return (10 - (totale % 10)) == ultimocarattere;   	     
				} 	 
			} catch (e) {
				return false;
			}
		};  
		
		return {
			checkCodFisc: function(cfins) {
				return _codFisc(cfins);
			},
			checkPartitaIva: function(s) {
				return _partIva(s);
			}
		};
	}
	return codFiscServices;	
});


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/resources/js/app/services/codfisc-services.js
// module id = 43
// module chunks = 1